import React from "react";
import { Box, Container , Flex, Text } from "theme-ui";
import { PostFooterMenu } from "./PostFooter.Menu";

const styles = {
    wrapper: {
        display: [`none`, null, `block`],
        position: `relative`,
        bg: `alpha`
      },
    }

export const PostFooter = () => {
    return (
        <Box sx={styles.wrapper}>
            <Container variant='compact' sx={styles.container}>
            <Flex variant='layout.subHeader'>
                <Box>
                    <Text sx={{color:'white'}}>Copyright © 2023 New Foundations Community Chaplaincy</Text>
                </Box>
                <PostFooterMenu/>
            </Flex>
            </Container>
        </Box>
    )
}